import React, { useState, Component } from 'react'
import AsyncSelect from 'react-select/async'
import { FormGroup, Label, FormFeedback } from 'reactstrap'
import { useField, useFormikContext } from 'formik'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import ApiFetcher from 'lib/api_fetcher'
import {get, debounce} from 'lodash'

const AddressSelector = ({ label, params, ...props }) => {
  const name = (props.field && props.field.name) || props.name
  const [field, meta] = useField(name)
  const {setFieldValue} = useFormikContext()
  const { t, i18n } = useTranslation()

  const components = get(params, 'components', 'country:es')

  const loadOptions = debounce((inputValue, callback) => {
    new ApiFetcher({
      key: 'address_autocomplete',
      endpoint: '/addresses/autocomplete',
      query: {input: inputValue, components: components}
    })
      .call()
      .then((res) => callback(res.response.map((feature) => ({label: feature.description, value: feature.description}))))
  }, 350)

  return (
    <FormGroup className={ meta.touched && meta.error ? 'has-error' : '' }>
      <Label className='control-label' htmlFor={props.id || props.name}>
        {label}
        {props.required &&
          <span className="text-danger ms-1">*</span>
        }
      </Label>
      <div
        style={{display: 'none'}}
        className={
          cn([
            'form-control',
            meta.touched && meta.error ? 'is-invalid' : '',
            meta.touched && !meta.error ? 'is-valid' : ''
          ])
        }
      >
      </div>
      <AsyncSelect
        placeholder={i18n.t('address_selector.placeholder')}
        cacheOptions
        loadOptions={loadOptions}
        onChange={(selected) => {
          setFieldValue(field.name, selected ? selected.value  : '')
        }}
        noOptionsMessage={() => i18n.t('address_selector.no_options')}
        {...props}
      />
      {meta.touched && meta.error ? (
        <FormFeedback className={'help-block'}>{meta.error}</FormFeedback>
      ) : null}
    </FormGroup>
  )
}

export default AddressSelector
